//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "CooperativeApplyDetail",
  data() {
    return {
      cooApplyId: "", //合作社申请id
      examineRecords: [], //审核记录
      detail: {},
      previeImgVisible: false,
      previewImgUrl: "",
    };
  },

  created() {
    let { cooApplyId } = this.$route.query;
    this.cooApplyId = cooApplyId;
    this.getCooperativeApplyDetail();
  },
  beforeRouteEnter(to, from, next) {
    let targetPath = "";
    switch (to.query.dataSource) {
      case "2":
        targetPath = "/cooperative/apply-examine/list";
        break;
      case "3":
        targetPath = "/cooperative/apply-examine/batch";
        break;
    }
    to.meta.targetPath = targetPath;
    next((vm) => {});
  },
  methods: {
    // 获取审核信息
    getCooperativeApplyDetail() {
      this.$http.cooperative
        .getCooperativeApplyDetail({ cooApplyId: this.cooApplyId })
        .then((res) => {
          this.detail = res.data;
        });
    },
    // 图片预览
    previeImg(imgUrl) {
      this.previewImgUrl = imgUrl;
      this.previeImgVisible = true;
    },
  },
};
